import TransformHeading from '@activebrands/core-web/libs/storyblok/utils/transform-heading';
import { graphql, useStaticQuery } from 'gatsby';

const useCategoryPageQuery = () => {
    const { application } = useStaticQuery(
        graphql`
            {
                application {
                    data {
                        config {
                            categoryPageConfig {
                                sortButtonLabel
                                pageContentBelowProducts
                                pageContentAboveProducts
                                noProductsTitle
                                gridContent
                                filterButtonLabel
                                filterSectionParagraph {
                                    ...Paragraph
                                }
                                filterSectionHeading {
                                    ...Heading
                                }
                                noProductsButtons {
                                    ...Button
                                }
                            }
                        }
                    }
                }
            }
        `
    );

    const content = application.data.config.categoryPageConfig || {};

    const transformedHeading = TransformHeading({
        heading: content.filterSectionHeading,
        defaultType: 'h3',
    });

    return {
        ...content,
        filterSectionHeading: transformedHeading,
        filterSectionParagraph: content.filterSectionParagraph?.[0]?.text,
    };
};

export default useCategoryPageQuery;
